import { keys } from '@core/Services/Analytics/keys'
import { trackKey } from '@core/Services/Analytics/track'

export const trackRacePromotionLoaded = () => trackKey(keys.racePromotionLoaded)
export const trackRacePromotionOpened = () => trackKey(keys.racePromotionOpened)
export const trackRacePromotionClosed = () => trackKey(keys.racePromotionClosed)
export const trackRacePromotionTermsAndConditionsClicked = () =>
  trackKey(keys.racePromotionTermsAndConditionsClicked)
